<h1 class="title">{{ 'wl.anz.multi_card_select.title' | translate }}</h1>
<p class="description">
  <span> {{ 'wl.anz.multi_card_select.description' | translate }} </span>
</p>

<ng-container
  *ngIf="pointsAccountFacade.pointsAccounts$ | async as pointsAccounts">
  <p class="balance-title">
    {{ 'wl.anz.multi_card_select.balance_title' | translate }}
  </p>
  <p class="balance-value">
    {{
      pointsAccountFacade.totalPointsBalance$
        | async
        | localizePointsNumber: '1.0-0'
    }}
    {{ (loyaltyCurrency$ | async).name }}
  </p>

  <anz-card-carousel
    *ngIf="!(pointsAccountFacade.loadPointsAccountsLoading$ | async)"
    [loyaltyCurrency]="loyaltyCurrency$ | async"
    [pointsAccounts]="pointsAccounts"
    [defaultPointsAccountId]="
      (userPreferenceFacade.userPreferences$ | async).pointsAccountId
    "></anz-card-carousel>

  <div
    class="loading-container"
    *ngIf="pointsAccountFacade.loadPointsAccountsLoading$ | async">
    <div>
      <rd-shared-spinner></rd-shared-spinner>
    </div>
  </div>
</ng-container>
